import { z } from "zod";

export const getSivDataByRegistrationNumberRequestSchema = z.object({
  registrationNumber: z.string(),
});

export type GetSivDataByRegistrationNumberRequest = z.infer<
  typeof getSivDataByRegistrationNumberRequestSchema
>;
